import React, {useEffect, useState} from "react";
import "../../../AccountAttributes/List/AccountList.css";
import "../../../Dashboard/Sidebar";
import ReactPaginate from 'react-paginate';
import Header from "../../../layout/header";
import DashboardMenu from "../../../layout/dashboardMenu";
import Loader from "../../../../Loader/Loader";
import NotFoundData from "../../../../Images/no-data-found.webp";
import Moment from "moment/moment";
import '../../../main_2.css'

const ExternalMomList = (
    {
        momListRequest,
        monListResponse = [],
        match,
    }
) => {
    const [isLoading, setIsLoading] = useState(false)
    const [pageNo, setPage] = useState(1)
    const [roleId, setRoleId] = useState("")

    useEffect(async () => {
        let roleId = localStorage.getItem('role_id')
        setRoleId(roleId)
        setIsLoading(true)
        await momListRequest(1, match?.params?.meeting_id, window.localStorage.module_type)
        setIsLoading(false)

    }, [])

    const onPageChange = async (val) => {
        setIsLoading(true)
        setPage(val?.selected + 1)
        await momListRequest(val?.selected + 1, match?.params?.meeting_id, window.localStorage.module_type)
        setIsLoading(false)
    };

    return (
        <>
            {/*<Sidebar/>*/}
            {/* section start  */}
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'Mom List'}
                        />
                        {/* <InnerMobileHeader
                          title={'Account List'}
                         /> */}
                        <div className="container-fluid common-bg">
                            {/*Heading*/}
                            <div className="container-fluid bootstrap snippets bg-white">
                                <div className="row b-13">
                                    {/*<div className="form-check form-switch global-search">*/}
                                    {/*    <input type="checkbox" id="switch" onChange={(e) => setIsGlobalSearch(e.target.checked)}/>*/}
                                    {/*    <label className="radio-btn" for="switch">Global Search</label>*/}
                                    {/*    <span className="serach-title">Search account globally..</span>*/}
                                    {/*</div>*/}
                                </div>
                                <div className="d-sm-flex align-items-center justify-content-between mt-2 mb-2">
                                    <div className="row col-md-12">
                                        <div className="col-md-6 col-sm-6 d-flex mt-20px">

                                            {/* <h1 className="h3 mb-0 text-black-100">Accounts</h1> */}
                                        </div>
                                    </div>
                                </div>
                                {/* Filter View End*/}
                                <div className="row">
                                    {/*CARD START*/}
                                    {monListResponse && monListResponse?.data !== undefined && monListResponse?.data !== [] && monListResponse?.data.map((val, i) => {
                                        return (
                                            <>
                                                <div className="col-md-4 col-sm-6">
                                                    <div className="card-big-shadow">
                                                        <div className="card card-just-text" data-background=""
                                                             data-color=""
                                                             data-radius="none">
                                                            <div className="content">
                                                                <h6 className="category mrg-b-12">
                                                                    <div className="row list-view">
                                                                        {val?.subject &&
                                                                            <div className="mb-flex">
                                                                                <div
                                                                                    className="col-md-6 col-sm-6 no-wrap">
                                                                                    <i className="fa fa-book"
                                                                                       aria-hidden="true"></i>&nbsp;&nbsp;Subject
                                                                                </div>
                                                                                <div className="col-md-6 col-sm-6 l2">
                                                                                    <span className="trigger"
                                                                                          data-tooltip-id="1"
                                                                                          title={val?.subject}>{val?.subject}</span>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                        {val?.body &&
                                                                            <div className="mb-flex">
                                                                                <div
                                                                                    className="col-md-6 col-sm-6 no-wrap">
                                                                                    <i className="bi bi-map"></i>&nbsp;&nbsp;Body
                                                                                </div>
                                                                                <div className="col-md-6 col-sm-6 l2">
                                                                                    <span className="trigger"
                                                                                          data-tooltip-id="1"
                                                                                          title={val?.body}>{val?.body}</span>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                        {val?.to_email !== null &&
                                                                            <div className="mb-flex">
                                                                                <div
                                                                                    className="col-md-6 col-sm-6 no-wrap">
                                                                                    <i className="bi bi-building"></i>&nbsp;&nbsp;To
                                                                                    Email
                                                                                </div>
                                                                                <div className="col-md-6 col-sm-6 l2">
                                                                                    <span className="trigger"
                                                                                          data-tooltip-id="1"
                                                                                          title={val?.to_email}>{val?.to_email}</span>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="fas fa-calendar-alt"></i>&nbsp;&nbsp;Created
                                                                                Date
                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">
                                                                                    <span className="trigger"
                                                                                          data-tooltip-id="1"
                                                                                          title={Moment(val?.created_at).format('DD-MM-YYYY')}>
                                                                                        {Moment(val?.created_at).format('DD-MM-YYYY')}
                                                                                    </span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="bi bi-person-lines-fill"></i>&nbsp;&nbsp;Created
                                                                                By
                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">
                                                                                    <span className="trigger"
                                                                                          data-tooltip-id="1"
                                                                                          title={val?.email}>
                                                                                        {val?.email}
                                                                                    </span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <hr/>
                                                                </h6>
                                                                <div className="row list-view-links">
                                                                    <ul>
                                                                        <li>
                                                                            <a style={{color: "rgb(149 150 40)"}}
                                                                                href={ `external-mom-view/${val?.id}`}
                                                                            >View</a>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                {/*<div className="col-sm-6">*/}
                                                                {/*    <a href={`valet-external-mom/${match?.params?.meeting_id}`}*/}
                                                                {/*       className="draft-float">*/}
                                                                {/*        <p className="my-float"*/}
                                                                {/*           style={{marginTop: "20px"}}><i*/}
                                                                {/*            className="fa fa-plus"*/}
                                                                {/*            aria-hidden="true"></i></p>*/}
                                                                {/*    </a>*/}
                                                                {/*</div>*/}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                    })}

                                    {monListResponse && monListResponse?.data !== undefined && monListResponse?.data.length > 0 &&
                                        <div className="panel-pagination-col panel-table-pagination">
                                            <ReactPaginate
                                                previousLabel={'<'}
                                                nextLabel={'>'}
                                                breakLabel={'...'}
                                                breakClassName={'break-me'}
                                                pageCount={(monListResponse?.total / monListResponse?.per_page)}
                                                forcePage={monListResponse?.current_page - 1}
                                                pageRangeDisplayed={4}
                                                onPageChange={onPageChange}
                                                activeClassName={'active'}
                                            />
                                        </div>
                                    }

                                    {monListResponse && monListResponse?.data !== undefined && monListResponse?.data.length === 0 &&
                                        <>
                                            <img src={NotFoundData} className="not-found-data"/>
                                            <div className="text-center" style={{"width": "100%"}}>
                                                Data Not Found
                                            </div>
                                            {/*<div className="col-sm-6">*/}
                                            {/*    <a href={`valet-external-mom/${match?.params?.meeting_id}`}*/}
                                            {/*       className="draft-float">*/}
                                            {/*        <p className="my-float" style={{marginTop: "20px"}}><i*/}
                                            {/*            className="fa fa-plus"*/}
                                            {/*            aria-hidden="true"></i></p>*/}
                                            {/*    </a>*/}
                                            {/*</div>*/}
                                        </>
                                    }
                                    {/*PAGINATION END*/}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* section ends */}
        </>
    )
}

export default ExternalMomList